import {useCurrentScopeContext} from '@/context/useCurrentScopeContext'
import {AppLink} from '@/ui/index'
import {DashboardBanner} from '@/ui/ui-components/features/dashboard-banner/DashboardBanner'
import {Badge} from '@/ui/ui-components/primitives/badge'
import {ArrowRightIcon} from '@sanity/icons'
import {Box, Button, Flex, Grid, Heading, Inline, Stack, Text, useTheme} from '@sanity/ui'
import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'

// "New" badge inside the primary button
// should always be blue text on white background
// regardless of light/dark mode
const ButtonBadge = styled(Badge)`
  background-color: rgb(255, 255, 255);
  margin-top: 1px;
  > div {
    color: #3b3fe7;
  }
`

export function TabPageHeader({
  title,
  icon,
  children,
  link,
  showDashboardCTA,
}: {
  title: string
  icon?: React.ReactNode
  children: React.ReactNode
  link?: {
    title: string
    href: string
  }
  showDashboardCTA?: boolean
}) {
  const {sanity} = useTheme()
  const linkColor = sanity.color.card.enabled.link.fg
  const {org} = useCurrentScopeContext()
  const isDashboardEnabled = org?.dashboardStatus === 'enabled'

  return (
    <Stack space={4}>
      <Flex align={['flex-start', 'flex-start', 'center', 'center']}>
        {!!icon && <Box marginRight={[3, 3, 5]}>{icon}</Box>}
        <Grid gap={[2, 2, 4]} autoFlow="column dense">
          <Box>
            <Flex>
              <Stack space={[3, 3, 4]}>
                {link && (
                  <Inline>
                    <AppLink href={link.href}>
                      <Text size={1} style={{color: linkColor}}>
                        {link.title}
                      </Text>
                    </AppLink>
                  </Inline>
                )}
                <Flex align={'center'} gap={4}>
                  <Heading size={[2, 2, 3]} as="h1">
                    {title}
                  </Heading>
                  {showDashboardCTA && isDashboardEnabled && (
                    <Button
                      as={Link}
                      text={'Open Dashboard'}
                      tone="primary"
                      icon={<ButtonBadge>New</ButtonBadge>}
                      iconRight={ArrowRightIcon}
                      target="_blank"
                      href={`/@${org?.id}`}
                    />
                  )}
                </Flex>
                <Box>{children}</Box>
              </Stack>
            </Flex>
          </Box>
        </Grid>
      </Flex>
      <DashboardBanner orgId={org?.id || ''} dashboardEnabled={isDashboardEnabled} />
    </Stack>
  )
}
